import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  Button,
  DropdownButton,
  Dropdown
} from 'react-bootstrap';

import { alertActions } from '../../../../../_actions/alert.actions';
import { retrieveFavorites, setFavorite, addFavoriteAndSet } from '../../../../../_actions/careplan.actions'
import { carePlanService as service } from '../../../../../_services/careplan.service';

class FavoriteCarePlans extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isUpdating: false,
      isSaving: false,
      showModal: false,
      favoriteName: '',
      favoriteLabel: 'Favorites'
    }
  }

  componentDidMount() {
    this.props.dispatch(retrieveFavorites());
  }

  render() {
    const { favoriteId, favorites, carePlan, dispatch } = this.props;
    const { showModal, isSaving, isUpdating, favoriteLabel } = this.state;

    const isDirty = carePlan.physicalExam !== '' || carePlan.imaging !== '' || carePlan.diagnosis !== '' || carePlan.carePlan !== '';

    return <>
      <DropdownButton variant="link"
        disabled={isUpdating}
        title={favoriteLabel}>
        {favorites.map((favorite) => {
          return <Dropdown.Item key={favorite.id}
            onClick={() => dispatch(setFavorite(favorite))}
            active={favoriteId === favorite.id}
          >{favorite.name}</Dropdown.Item>
        })}

        {favorites.length > 0 && (isDirty || favoriteId) &&
          <Dropdown.Divider />
        }

        {favoriteId &&
          <Dropdown.Item onClick={() => {
            this.setState({
              isUpdating: true,
              favoriteLabel: 'Updating...'
            });

            service.updateFavorite(favoriteId, carePlan)
              .then(() => {
                this.setState({
                  isUpdating: false,
                  favoriteLabel: 'Updated!'
                });

                this.props.dispatch(retrieveFavorites());

                setTimeout(() => {
                  this.setState({ favoriteLabel: 'Favorites' });
                }, 2500);
              })
              .catch(() => {
                this.setState({ isUpdating: false, favoriteLabel: 'Favorites' });
                dispatch(alertActions.error('Could not update favorite as this time.'));
              });
          }}>Update Current</Dropdown.Item>
        }

        {isDirty &&
          <Dropdown.Item onClick={() => this.setState({ showModal: true })}>Save as New Favorite</Dropdown.Item>
        }
      </DropdownButton>

      <Modal show={showModal} onHide={() => { this.setState({ showModal: false }) }}>
        <Modal.Header closeButton>
          <Modal.Title>Save Favorite</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <h6>Favorite Name:</h6>
          <input onChange={(e) => this.setState({ favoriteName: e.target.value })} type="text" className="form-control" />
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={() => {
            this.setState({
              isSaving: true,
              favoriteLabel: 'Saving...'
            });

            service.saveFavorite(this.state.favoriteName, carePlan)
              .then((favorite) => {
                this.setState({
                  showModal: false,
                  isSaving: false,
                  favoriteLabel: 'Saved!'
                });

                setTimeout(() => {
                  this.setState({ favoriteLabel: 'Favorites' });
                }, 2500);

                dispatch(addFavoriteAndSet(favorite));
              })
              .catch(() => {
                this.setState({ showModal: false, isSaving: false, favoriteLabel: 'Favorites' });
                dispatch(alertActions.error('Could not save favorite as this time.'));
              });
          }}
            disabled={this.state.favoriteName === '' || isSaving}
            variant="primary">{isSaving ? 'Saving...' : 'Save Favorite'}</Button>

          <Button variant="secondary" onClick={() => this.setState({ showModal: false })}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  }
}

const mapStateToProps = state => {
  return {
    favoriteId: state.careplan.favoriteId,
    favorites: state.careplan.favorites,
    carePlan: state.careplan.current
  }
}

export default connect(mapStateToProps)(FavoriteCarePlans)